import { createContext } from 'react';

const lawContext = createContext();

export default lawContext;
